<template>
  <header class="header">
    <div class="header__inner-container">
      <a class="header__logo-wrapper" href="https://pkw.de">
        <img src="../../assets/images/logo.png" alt="PKW.de Logo" />
      </a>
      <p @click="openModal" class="hint">14 Tage Rückgaberecht <i class="fas fa-info-circle" style="cursor:pointer" /></p>
      <a href="tel:00492119462550" class="header__phone-number-wrap">
        <img src="../../assets/images/help.png" alt="Brauchen Sie Hilfe?" />
        <div class="text">
          <p>Ihre PKW.de Experten</p>
          <p class="header__phone-number">+49 211 946 255 0</p>
        </div>
      </a>
      <DaysModal :isOpen="showModal" @close="closeModal" />
    </div>
  </header>
</template>

<script>
import DaysModal from "../modals/14DaysModal.vue"
export default {
  props: ['status', 'number'],
  components: {
    DaysModal
  },
  data() {
    return {
      showModal: false,
      showContactModal: true,
    };
  },
  computed: {
    step1() {
      return this.$route.name === '1';
    },
    step4() {
      return this.$route.name === '4';
    },
    step5() {
      return this.$route.name === '5';
    },
    errorPage() {
      return this.$route.name === 'error';
    },
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 0.0625rem solid $border-gray;
  &__inner-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 4rem;
    padding: 0 0 0 0.9375rem;
    background-color: $white;
    position: relative;
    margin-bottom:31px;
    @include breakpoint(desktop) {
      height: auto;
      
    }
    @include breakpoint(tablet) { 
      margin-bottom:0;
    }

    .hint {
      font-size: 14px;
      display: block;
      position: absolute;
      bottom: -28px;
      font-weight: bold;
      background: white;
      color: #131313;
      padding: 4px 0;
      margin: auto;
      left:0;
      right:0;
      text-align: center;

      @include breakpoint(tablet) {
        position: relative;
        bottom: auto;
        
        i {
          display: inline-block;
        }
      }

      @include breakpoint(medium) {
        font-size: 20px;
      }
    }
  }
  &__logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100px;

    @include breakpoint(tablet) {
      width: 143px;
      height: 46px;
    }

    img {
      width: 100%;
    }
  }
  h1 {
    justify-self: flex-start;
    margin-right: auto;
    padding-left: 1.25rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 0.875rem;
    color: $black;
  }
  &__phone-number-wrap {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0.625rem;
    height: 100%;
    background-color: rgba($darkgray, .1);
    color: #131313;
    font-weight: bold;

    img {
      height: 35px;
      width: 35px;
      border-radius:50%;
      display: block;
      border: 1px solid #dadada;
      margin-right: 10px;
    }

    p {
      font-size: 13px;
      line-height: 0.875rem;
    }
    p span {
      display: none;
    }
  }
  &__phone-number {
    font-weight: normal;
  }
  @include breakpoint(tablet) {
    &__phone-number-wrap {
      p {
        font-weight: 700;
        font-size: 16px;
        line-height: 0.875rem;
        span {
          display: initial;
        }
      }
      .header__phone-number {
        display: initial;
        font-weight: 400;
      }
    }
  }
  @include breakpoint(desktop) {
    background-color: $white;
    margin-bottom: 3rem;
    h1 {
      margin-right: initial;
      font-size: 0.875rem;
      font-weight: 700;
    }
    &__inner-container {
      height: 4.0625rem;
      margin: 0 auto;
    }
    &__phone-number-wrap {
      width: 330px;
      padding: 10px 20px;

      img {
        width: 50px;
        height: 50px;
      }

      &:before {
        font-size: 18px;
        left: 2.25rem;
        transform: translate(50%, 0);
      }
      p {
        font-size: 18px;
        line-height: 24px;
        span {
          display: initial;
        }
      }
      .header__phone-number {
        font-size: 18px;
      }
    }
  }
  @include breakpoint(bigdesktop) {
    &__inner-container {
      width: 71.25rem;
      padding: 0 0.9375rem;
    }
  }
}
</style>
